import { render, staticRenderFns } from "./SidebarListQuestions.vue?vue&type=template&id=11c649cb"
import script from "./SidebarListQuestions.vue?vue&type=script&lang=js"
export * from "./SidebarListQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports